<template >
  <v-container fill-height>
    <v-row justify="center" align="center">
      <v-col cols="12" xs="3" sm="12" md="12" lg="12" xl="12">
        <img :src="require('@/assets/images/logo_zagonel_white.png')"/>
      </v-col>
      <v-col cols="12" align="center">
        <v-form @submit.prevent="login" ref="form">
          <v-card max-width="450px" class="align-center justify-center">
            <v-row class="col-sm-12" >
              <v-col cols="12" sm="12" md="12">
                <v-text-field label="Login" color="#145637" dense outlined hide-details v-model="form.login" :rules="emptyRule" />
              </v-col>
              <v-col class="field" cols="12">
                <v-text-field label="Senha" color="#145637" dense outlined hide-details v-model="form.password" :type="show ? 'text' : 'password'" :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'" @click:append="show = !show" :rules="emptyRule"/>
              </v-col>
              <v-col cols="12">
                <v-btn color="success" type="submit" block>
                  ENTRAR
                </v-btn>
              </v-col>
              <v-col cols="12" sm="12" md="12">
                <v-btn color="primary" block @click="navigateToRegisterAssistant">
                  CADASTRAR
                </v-btn>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="pt-0">
                Baixar manual de uso do sistema: <v-icon @click="dowload">mdi-download</v-icon>
              </v-col>
            </v-row>
          </v-card>
        </v-form>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>

export default {

  data: () => ({
    emptyRule: [
      v => !!v || 'Preenchimento obrigatório',
      // v => /^\d+$/.test(v) || 'Must be a number',
    ],
    form: {
      login: '',
      password: '',
      loading: false,
    },
    snackbar: true,
    show: false,
    text: 'Bem Vindo ao novo sistema da assistência Técnica Zagonel!',
  }),

  methods: {
    async navigateToRegisterAssistant() {
      await this.$router.push('/register')
    },
    async getFullName(name) {
      await this.$http.get(`/user/get-full-name?login=${name}`).then (resp => {
          console.log(resp)
          localStorage.setItem('user', resp.data.fullName);
        }) .catch(error => {console.log(error)})
    },

    async login() {
      if (!this.$refs.form.validate()) {
        this.$toast.error('Preencha todos os dados')
        return
      }

      await this.$http.post('/auth', this.form).then(async result => {
        if (result.data.error) {
          this.$toast.error(result.data.msg);
          return;
        }

        localStorage.setItem('x-access-token', result.data.token);
        
       

        this.$http.defaults.headers.common = {
          'x-access-token': result.data.token,
        };

        this.getFullName(this.form.login)
        
        let role = null

        this.$http.get('/token').then(result => {
          role = result.data.role

          if(role === 1) {
            this.$router.push('/assistant')
          }

          if(role === 2) {
            this.$router.push('/order-adm')
          }

          if(role === 3) {
            this.$router.push('/panel')
          }

          if(role === 4) {
            this.$router.push('/menu-lumination')
          }

          if(role === 5) {
            this.$router.push('/order-adm-ilumination')
          }
        })
      })
    },
    async dowload () {
      const result = await this.$http.get('/file?filename=bc117e46acb23e74b8033a1247ea407a-GUIA NOVO SISTEMA ASSISTENTES TECNICOS.pdf')
      const a = document.createElement("a");
      a.href = `data:application/pdf;base64, ${result.data.base64}`
      a.download = `image.pdf`;
      a.click();
    }
  },
  mounted() {
    localStorage.removeItem('x-access-token')
  }
}
</script>
<style>

</style>
